import { event } from 'vue-analytics'
import Vue from 'vue'
import store from '@/store'

const track = (obj) => {
  if (Vue.gtm) {
    try {
      event(obj.category, obj.action, obj.label, obj.value)
      Vue.gtm.push(obj)
    }
    catch(err) {
      console.log('Tracking unavailable')
    }
  }
}

export default track
